//Yearly
export enum Months {
  None,
  Jan,
  Feb,
  Mar,
  Apr,
  May,
  Jun,
  Jul,
  Aug,
  Sep,
  Oct,
  Nov,
  Dec
}

//Weekly
export enum Weekdays {
  Sun,
  Mon,
  Tue,
  Wed,
  Thu,
  Fri,
  Sat
}

//Monthly
export enum DaysOfMonth {
  st,
  nd,
  rd,
  th
}

//Schedule status
export enum Status {
  Yet_to_start = 0,
  In_Progress = 1,
  Completed = 2,
  Paused = -1,
  Error = 3
}
